export const CHANGE_MENU_ADD = 'CHANGE_MENU_ADD';
export const CHANGE_MENU_REMOVE = 'CHANGE_MENU_REMOVE';
export const CHANGE_RANGE = 'CHANGE_RANGE';
